import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BookingDataService from "../../services/Booking";
import { useToast } from "@chakra-ui/react";
import { SingleBookingDetailsList } from "../../components/List/SingleBookingDetailsList";
export const SingleBookingDetails = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const loggedInUserEmail = localStorage.getItem("logged_in_email");
  const navigate = useNavigate();
  const toast = useToast();
  const [list, setList] = useState<any>();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [search, setSearch] = useState("");
  const [sortingType, setSortingType] = useState("session_date");
  const [sessionCount, setSessionCount] = useState("");

  const allowedEmails = ["tamannar@manoshala.com", "community@manoshala.com"];

  const isLoggedInUserAllowed =
    loggedInUserEmail !== null && allowedEmails.includes(loggedInUserEmail);

  const fetchData = async () => {
    BookingDataService.getSingleBookingDetails(
      page,
      pageSize,
      search,
      sessionCount,
      sortingType
    )
      .then((res: any) => {
        setList(res.data.users);
        setTotalPages(res.data.totalPages);
        setTotalUsers(res.data.totalUsers);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };
  useEffect(() => {
    fetchData();
  }, [page]);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Bookings - Single Bookings</div>
        <div className="p-4">
          <div className="top_section_container">
            <div className="top_section_lower_container ">
              <div className="nested p-lg-0 ">
                <div className="input-group">
                  <select
                    className="form-control filter-sec"
                    id="lead_status"
                    value={sortingType}
                    onChange={(e) => {
                      setSortingType(e.target.value);
                    }}
                  >
                    <option value="">Please select</option>
                    <option value="session_date">
                      Sort by Latest session date
                    </option>
                    <option value="total_count">
                      Sort by Total booking count
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div className="top_section_lower_container ">
              <div className="nested p-lg-0">
                <div className="input-group">
                  <input
                    className="form-control filter-sec"
                    id="lead_status"
                    placeholder="Search by email, phone or name"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="top_section_lower_container">
              <div className="nested p-lg-0">
                <div className="">
                  <input
                    className="form-control filter-sec"
                    id="lead_status"
                    placeholder="Number of session"
                    value={sessionCount}
                    onChange={(e) => setSessionCount(e.target.value)}
                  />
                </div>
              </div>

              <div className="nested p-lg-0">
                <div className="d-flex justify-content-end">
                  <button
                    className="btn action-btn search-btn"
                    type="button"
                    onClick={() => {
                      setPage(1);
                      fetchData();
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  <th>User Name</th>
                  <th>User Email</th>
                  {isLoggedInUserAllowed && <th>User Phone</th>}
                  <th>Subscription</th>
                  <th>Total Single Bookings</th>
                  <th>Expert Name</th>
                  <th>Expert Booking Count</th>
                  <th>Latest Session Date</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleBookingDetailsList
                      key={el.uuid}
                      id={el.uuid}
                      props={el}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
          <div className="row m-0 pagination pt-5">
            <div className="col-sm-6 p-lg-0">
              <p>
                Showing {(page - 1) * pageSize + 1} to{" "}
                {page * pageSize > totalUsers ? totalUsers : page * pageSize} of{" "}
                {totalUsers} entries
              </p>
            </div>
            <div className="col-sm-6 p-lg-0 text-right">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={
                    page === 1
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPage(page - 1)}
                  disabled={page === 1 ? true : false}
                >
                  {"<< Previous"}
                </button>
                <button type="button" className="btn action-btn selected">
                  {page}
                </button>
                <button
                  type="button"
                  className={
                    page === totalPages || totalPages === 0
                      ? "btn action-btn disabledButton "
                      : "btn action-btn"
                  }
                  onClick={() => setPage(page + 1)}
                  disabled={
                    page === totalPages || totalPages === 0 ? true : false
                  }
                >
                  {"Next >>"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
